module.exports = __webpack_public_path__ + "img/logo.1716124a.png";